/**
 * 平台成本档清单（N-167，超管维护，全平台单份）——三份有序模型清单，键为 `economy` / `standard` /
 * `premium`。每份条目与平台默认主脑优先级同形（`{ modelId }`），经 `buildBrainPriorityList` 同一归一：
 * 剥能力后缀、保留 `[pi]` 链路后缀、去重保序。某份归一后为空 = 该档未配置（键省略）。
 *
 * 组织可以按档整份替换（`ModelBucketCuration` 的同名键），统一选模型函数（`task-model-chain.ts`）
 * 先看组织那份、没有才用这里的。
 */
import { buildBrainPriorityList } from "./brain-priority.js";
export const COST_TIERS = ["economy", "standard", "premium"];
export function isCostTier(value) {
    return typeof value === "string" && COST_TIERS.includes(value);
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function normalizeTiers(raw) {
    if (!isRecord(raw))
        return {};
    const tiers = {};
    for (const tier of COST_TIERS) {
        // 归一只走主脑优先级的唯一构建器（元数据在这里不用，取 entries）。
        const entries = buildBrainPriorityList(raw[tier], "")?.entries;
        if (entries)
            tiers[tier] = entries;
    }
    return tiers;
}
/**
 * 唯一写入构建器：接受 `{ economy, standard, premium }`（每档 string[] 或 `{modelId}[]`）。
 * 未知键丢弃；三档都空也返回一份（表示超管清空了全部档），由调用方决定是否存。
 */
export function buildModelCostTiers(input, meta) {
    return {
        tiers: normalizeTiers(input),
        editedAt: (meta.now ?? new Date()).toISOString(),
        editedBy: meta.editedBy,
    };
}
/** 读库 / 读 wire 的边界 guard：整体畸形返回 undefined；坏条目跳过；元数据缺失降为空串。 */
export function parseModelCostTiers(raw) {
    if (!isRecord(raw) || !isRecord(raw.tiers))
        return undefined;
    return {
        tiers: normalizeTiers(raw.tiers),
        editedAt: typeof raw.editedAt === "string" ? raw.editedAt : "",
        editedBy: typeof raw.editedBy === "string" ? raw.editedBy : "",
    };
}
/** 某一档的平台清单；未配置返回空数组。 */
export function costTierEntries(costTiers, tier) {
    return costTiers?.tiers[tier] ?? [];
}
//# sourceMappingURL=model-cost-tiers.js.map